//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectionsMixin from '~/mixins/SelectionsMixin'
import Header from '~sdp-components/Header/Header'
import Navigation from '~/components/Navigation'
import Footer from '~sdp-components/Footer/Footer'
import Columns from '~sdp-components/PageElements/Columns'
import Column from '~sdp-components/PageElements/Column'
import QlikCollapsableFilterContainer from '~sdp-components/Qlik/QlikCollapsableFilterContainer'
import QlikSelectedFilterPills from '~sdp-components/Qlik/QlikSelectedFilterPills'
import QlikFilter from '~sdp-components/Qlik/QlikFilter'
import Square from '~sdp-components/PageElements/Square'
import Heading from '~sdp-components/PageElements/Heading'
import Content from '~sdp-components/PageElements/Content'

export default {
  components: {
    Header,
    Navigation,
    Footer,
    Columns,
    Column,
    QlikFilter,
    QlikCollapsableFilterContainer,
    QlikSelectedFilterPills,
    Square,
    Heading,
    Content,
  },
  mixins: [SelectionsMixin],
  computed: {
    filterFields() {
      return [
        { field: 'Sector' },
        { field: 'Current Network', label: 'Network' },
        { field: 'Test (inc. PASA)', label: 'Test Type' },
        { field: 'Current School Level', label: 'School Level'},
        { field: 'Current Admission Type', label: 'Admission Type'},
        { field: 'Grade Level', label: 'Grade Level' },
        { field: 'Race/Ethnicity', label: 'Race/Ethnicity' },
        { field: 'Gender' },
        { field: 'Economic Disadvantage', label: 'Economic Disadvantage' },
        { field: 'Special Education', label: 'Special Education' },
        { field: 'EL Status', label: 'EL Status' },
        //{ field: 'School Year' },
      ]
    },
    tourSteps() {
      return [
        {
          target: '#main-title',
          content:
            'Welcome to the PSSA/Keystone website. Here you can find data about school and studnet performance on Pennsylvania assessments for both district and public charter schools in Philadelphia.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#nav-overview',
          content:
            'This website is divided into four sections. You can navigate to any of these sections at any time.',
          params: { enableScrolling: false },
        },
        {
          target: '#nav-ela',
          content:
            'The ELA, Math, and Science pages display information about performance on specific subject exams.',
          params: { enableScrolling: false },
        },
        {
          target: '#main-content-side',
          content:
            'Here you can view charts, maps, and tables related to student performance.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#main-filter-panel',
          content:
            'On this panel you can find a number of filters to narrow down the displayed schools and student groups.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#main-filters',
          content:
            'Use the filters to narrow down school or student characteristics.',
          params: { enableScrolling: false },
        },
        {
          target: '#main-school-filter',
          content: 'Use the school filter to choose one or more schools.',
          params: { enableScrolling: false },
        },
        {
          target: '#main-tour-button',
          content: 'Press here to take this tour again.',
          params: { enableScrolling: true },
          offset: -400,
        },
      ]
    },

    tourCallbacks() {
      return {
        onSkip: () => this.$store.dispatch('tour/initialize_main'),
        onFinish: () => this.$store.dispatch('tour/initialize_main'),
      }
    },
  },
  mounted() {
    if (!this.$store.state.tour.main_initialized) this.launchTour()
  },
  /**
   * Remove field values that we don't want to carry to other pages
   */
  async destroyed() {
    const fieldsToClear = []
    const engine = await this.$qlik.engine
    let field
    fieldsToClear.forEach(async (fieldName) => {
      field = await engine.getField(fieldName)
      await field.clear()
    })
  },
  methods: {
    launchTour() {
      this.$tours.mainTour.start()
    },
  },
}
